import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { AIRTABLE_URL, AIRTABLE_HEADERS } from "./constants";

export default function TechnicianComplaintView() {
  const [complaints, setComplaints] = useState([]);
  const [technicianPhone] = useState(localStorage.getItem("technicianPhone") || "");
  const [responses, setResponses] = useState({});
  const navigate = useNavigate();

  const fetchData = useCallback(async () => {
    try {
      const res = await fetch(AIRTABLE_URL, {
        headers: AIRTABLE_HEADERS,
      });

      const data = await res.json();

      console.log("📱 technicianPhone from localStorage:", technicianPhone);
      console.log("📋 Fetched records:", data.records);

      const assigned = data.records.filter(
        (row) =>
          row.fields.assignedTechnicianPhone?.trim() === technicianPhone.trim()
      );

      setComplaints(assigned);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [technicianPhone]);

  const handleResponseChange = (key, value) => {
    setResponses((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleResolve = async (recordId, fieldToUpdate, responseField, responseText) => {
    let warningMessage = "";

    if (fieldToUpdate === "complaintStatus") {
      warningMessage =
        "⚠️ Please double-check. Have you truly solved the issue? Marking as resolved without fixing it can create bigger problems. Don’t mark resolved before solving the issue. If you do, you may be terminated.";
    } else if (fieldToUpdate === "complaintStatusAgain") {
      warningMessage =
        "⚠️ This is the second complaint for this order. Unresolved complaints damage customer trust and our reputation. Ensure you’ve truly fixed the issue before proceeding.";
    } else if (fieldToUpdate === "complaintStatusAgain3") {
      warningMessage =
        "🚨 FINAL WARNING: This is the third complaint from the same customer. If not resolved correctly, serious action may be taken. Are you absolutely sure?";
    }

    const confirmed = window.confirm(warningMessage);
    if (!confirmed) return;

    try {
      await fetch(`${AIRTABLE_URL}/${recordId}`, {
        method: "PATCH",
        headers: AIRTABLE_HEADERS,
        body: JSON.stringify({
          fields: {
            [fieldToUpdate]: "Resolved",
            [responseField]: responseText,
          },
        }),
      });

      alert("✅ Complaint marked as Resolved with response!");
      fetchData();
    } catch (err) {
      alert("❌ Failed to update status or response");
      console.error(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div style={{ padding: 30, maxWidth: 800, margin: "auto" }}>
      <div style={{ textAlign: "right" }}>
        <button
          onClick={() => navigate("/technician-home")}
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            background: "none",
            border: "none",
            fontSize: 20,
            cursor: "pointer",
            color: "Black"
          }}
        >
          ✖
        </button>
      </div>

      <h2>🛠️ Assigned Complaints</h2>

      {complaints.length === 0 ? (
        <p>No complaints assigned to this number.</p>
      ) : (
        complaints.map((item) => {
          const blocks = [];

          const statusFields = [
            {
              status: item.fields.complaintStatus,
              field: "complaintStatus",
              category: item.fields.complaintCategory,
              complaint: item.fields.complaint,
              responseField: "complaintResponse"
            },
            {
              status: item.fields.complaintStatusAgain,
              field: "complaintStatusAgain",
              category: item.fields.complaintCategoryAgain,
              complaint: item.fields.complaintAgain,
              responseField: "complaintResponseAgain"
            },
            {
              status: item.fields.complaintStatusAgain3,
              field: "complaintStatusAgain3",
              category: item.fields.complaintCategoryAgain3,
              complaint: item.fields.complaintAgain3,
              responseField: "complaintResponseAgain3"
            }
          ];

          statusFields.forEach(({ status, field, category, complaint, responseField }) => {
            if (status?.trim() === "Pending") {
              const key = item.id + field;
              const complaintNumber = field === "complaintStatus" ? "1" : field === "complaintStatusAgain" ? "2" : "3";

              blocks.push(
                <div key={key} style={{ border: "1px solid #ccc", borderRadius: 6, padding: 15, marginBottom: 10 }}>
                  <h4>Complaint Level #{complaintNumber}</h4>
                  <p><b>Name:</b> {item.fields.name}</p>
                  <p><b>Mobile Number:</b> {item.fields.phone}</p>
                  <p><b>Address:</b> {item.fields.address}</p>
                  <p><b>Pincode:</b> {item.fields.pincode}</p>
                  <p><b>Landmark:</b> {item.fields.landmark}</p>
                  <p><b>Order ID:</b> {item.fields.orderId}</p>
                  <p><b>Grand Totel:</b> {item.fields.grandTotal}</p>
                  <p><b>Category:</b> {category}</p>
                  <p><b>Customer Complaint:</b> {complaint}</p>
                  <p><b>Technician Status:</b> {status}</p>

                  <textarea
                    rows={3}
                    placeholder="✍️ Enter your response..."
                    style={{ width: "100%", padding: 8, marginTop: 10 }}
                    value={responses[key] || ""}
                    onChange={(e) => handleResponseChange(key, e.target.value)}
                  />

                  <button
                    onClick={() => handleResolve(item.id, field, responseField, responses[key] || "")}
                    style={{
                      marginTop: 10,
                      backgroundColor: "#28a745",
                      color: "white",
                      padding: "8px 16px",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    ✅ Mark as Resolved
                  </button>
                </div>
              );
            }
          });

          return blocks;
        })
      )}
    </div>
  );
}
